import React, { useEffect } from 'react';
import { KFLButton, KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import DialogHeader from '../../shared/dialog/dialogHeader';
import Translate from '../../shared/localization/localize';
import DialogSection from '../../shared/dialog/dialogSection';
import {
  TransferDialogs,
  TransferStatus,
} from '../../../modules/dialogs/transfer';
import TransferSummary, {
  roundFailIcon,
  roundOkIcon,
} from './transferSummary';
import Scrim from '../../shared/scrim';
import * as m from '../../../modules/dialogs/transfer/messages';
import useTxRequest from '../../../modules/dialogs/transfer/useTxRequest';
import DialogFooter from '../../shared/dialog/dialogFooter';
import useLocale from '../../../hooks/useLocale';
import SandwichBox from '../../shared/sandwichBox';

const TxDialogReqFinal: React.FC = () => {
  const { translate } = useLocale();
  const {
    tx,
    changeScreen,
    closePanel,
    createRequest,
    createRequestStatus,
  } = useTxRequest();

  useEffect(() => {
    isConfirmed ? createRequest() : changeScreen(TransferDialogs.REQUEST);
  }, []);

  const isConfirmed = tx.status === TransferStatus.CONFIRMED;
  const isPending = tx.status === TransferStatus.PENDING;

  const summaryLogo = createRequestStatus.errorMsg
    ? roundFailIcon
    : roundOkIcon;
  const summaryHeader = createRequestStatus.errorMsg
    ? m.msgCreatingTxError
    : m.msgReqTransferSucceed;

  const content = (
    <>
      <DialogSection isMain scrollable>
        <Scrim
          isActive={createRequestStatus.isFetching}
          label={m.msgCreatingTx}
          iconSize={16}
          fullHeight
        >
          {createRequestStatus.isFetching ? (
            <></>
          ) : (
            <SandwichBox
              bottom_bun={
                <SandwichBox>
                  {!isPending && (
                    <div className={'tx_failed_box'}>
                      <KFLButton
                        id="dg-tx-req-bt-refinish"
                        onClick={() => createRequest()}
                      >
                        {translate(m.msgRetryBtn)}
                      </KFLButton>
                    </div>
                  )}
                </SandwichBox>
              }
            >
              <TransferSummary
                transfer={tx}
                title={summaryHeader}
                icon={summaryLogo}
              ></TransferSummary>{' '}
            </SandwichBox>
          )}{' '}
        </Scrim>
      </DialogSection>
    </>
  );

  const activitiesBtn = (
    <KFLButton
      id="dg-tx-req-bt-activities"
      variant="secondary"
      onClick={() => changeScreen(TransferDialogs.ACTIVITIES)}
    >
      {translate(m.msgActivitiesBtn)}
    </KFLButton>
  );

  return (
    <KFLDialog
      header={
        <DialogHeader
          title={<Translate message={m.msgHeaderReq} />}
          fnCloseDialog={closePanel}
          fnBackDialog={
            isPending ? () => changeScreen(TransferDialogs.REQUEST) : undefined
          }
        />
      }
      sections={[content]}
      footer={
        <DialogFooter
          leftContent={isPending ? activitiesBtn : ''}
          buttons={[]}
          hideCancelBtn
          fnCloseDialog={closePanel}
        />
      }
    />
  );
};
export default TxDialogReqFinal;
